// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__dUVX5","location":"Header_location__3Cdpe"};